'use strict';

module.exports = function (str) {
    if (this.options.debugMode) {
        console.log(str + '%c', 'color: #009ACD');
    }
};


// WEBPACK FOOTER //
// ./node_modules/swup/lib/modules/log.js